import { sha224 } from 'js-sha256';
export const getDefaultEntityId = (context) => sha224(context.page?.uri);
